import * as React from 'react';
import { StyleSheet, ScrollView } from 'react-native';

export const KeyboardAwareScrollView = props => (
  <ScrollView contentContainerStyle={styles.container}>{props.children}</ScrollView>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
